import { LuSearch } from "@/Components/Icons/Icons.jsx"
export default {
    row1: [
        {
            column: "column1",


            rows: {
                row1: [
                    {
                        name: "Scheme No & Date",
                        actionText: "Scheme No & Date",
                        component: "typographytext",
                        width: "15%"
                    },

                    {
                        name: "re-Initialize",
                        label: "Re-Initialize",
                        component: "outlinebutton",
                        action: "GoToCreateCustomer",
                        variant: "bodySmallMedium",
                        width: "10%",
                        sx: {
                            mt: "5px",
                        },
                    },



                ],
                row2: [


                    {
                        name: "schemeNumber",
                        component: "textarea",
                        disabled: false,
                        width: "95%",
                        sx: {
                            height: "40%",
                            borderRadius: 10,
                        },
                    },
                ]

            }
        }
    ]
}

